<template>
  <div class="page">
    <div class="container">
      <div class="page__row">
        <div class="animation__triangle">
          <div class="page__inner">
            <div class="page__in">
              <h1 class="title title_red page__title" style="margin-top: 200px">Individualism</h1>
              <p class="lead page__lead individualism__title_type_2" style="margin-bottom: auto;">Every person is important to us. We respect and support our employees’ commitment to realizing their potential</p>
            </div>
          </div>
          <div class="page__inner">
            <div class="page__in">
              <h1 class="title title_red page__title" style="margin-top: 200px">Attitude</h1>
              <p class="lead page__lead individualism__title_type_2" style="margin-bottom: auto;">We value open attitudes and a good sense of humour. We share expertise and help each other to grow and develop</p>
            </div>
          </div>
          <div class="page__inner">
            <div class="page__in">
              <h1 class="title title_red page__title" style="margin-top: 200px">Movement</h1>
              <p class="lead page__lead individualism__title_type_2" style="margin-bottom: auto;">We are driven by the energy of movement and continuous development; we actively pursue innovative ideas, inspired by everything around us</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <individualism-background />

    <page-footer
      :next="{ name: 'relations-en' }"
    />
  </div>
</template>

<script>
// eslint-disable-next-line
import { TimelineMax, TweenMax } from 'gsap'
import IndividualismBackground from '@/components/aboutSvg'
import PageFooter from '@/components/PageFooter'
import RouteMixin from '@/views/mixins/route'

export default {
  name: 'individualism-en',
  mixins: [RouteMixin],
  components: {
    IndividualismBackground,
    PageFooter
  },
  mounted () {
    new TimelineMax()
      .add(TweenMax.from('.individualism-bg', 0.5, { opacity: 0 }))
      .add(TweenMax.from('.page__title', 0.3, { y: '-30px', opacity: 0 }))
      .add(TweenMax.from('.page__lead', 0.3, { y: '-10px', opacity: 0 }))
      .add(TweenMax.from('.individualism__subtitle', 0.3, { y: '-10px', opacity: 0 }))
  },
  beforeRouteLeave (to, from, next) {
    this.isDisabledRoute = true

    new TimelineMax()
      .add(TweenMax.to('.page__lead', 0.3, { y: '10px', opacity: 0 }))
      .add(TweenMax.to('.page__title', 0.3, { y: '30px', opacity: 0 }))
      .add(TweenMax.to('.individualism__subtitle', 0.3, { y: '30px', opacity: 0 }))
      .add(TweenMax.to('.individualism-bg', 0.5, { opacity: 0 }))
      .eventCallback('onComplete', () => {
        next()
      })
  }
}
</script>
